import { Controller } from "@hotwired/stimulus"
import $ from "jquery"
import Twig from 'twig'


import "../../css/blocks/tmpl-banners.css"
import "../../css/blocks/card.css"
import "../../css/blocks/family.css"
import "../../css/blocks/doctor.css"
import "../../css/blocks/myinfo.css"
import "../../css/blocks/feedback.css"


export default class extends Controller {
    deferredPrompt;


    cardRotate(){
        const windowInnerWidth = window.innerWidth;
        const windowInnerHeight = window.innerHeight;
        console.debug(windowInnerWidth);
        console.debug(windowInnerHeight);
        let card = $('#card');
        let cardBox = $('.card__box');

        card.toggleClass('show');
        $('body').toggleClass('card-show');
        $('.index-content').toggleClass('card-rotate');
        let cardAnimation = $('#card').attr('class');
        if (cardAnimation === 'card show'){
            $('#canvas').attr('style','width:180px;height:180px');
        } else {
            $('#canvas').attr('style','width:90px;height:90px');
        }
/*        if(window.innerHeight > window.innerWidth){

        }*/

      /*  if (card.hasClass('show')) {
            cardBox.css('width',windowInnerHeight);
            cardBox.css('height',windowInnerWidth);
        }
        else{
            cardBox.removeAttr("style");
        }*/
    }


    connect() {
        let self = this;
        window.addEventListener('beforeinstallprompt', (event) => {
            console.debug('addEventListener');
            // Prevent the mini-infobar from appearing on mobile.
            event.preventDefault();
            if (global.hasInstall === 'false'){
                return
            }

            console.log('👍', 'beforeinstallprompt', event);
            // Stash the event so it can be triggered later.
            self.deferredPrompt = event;
            // Remove the 'hidden' class from the install button container.
            /*$('#install').attr('hidden', false);
            $('#install').attr('style', 'display:flex');*/
            $('#install').addClass('active');
        });

        $('#installBtn').click(
            async () => {
                console.log('👍', 'butInstall-clicked');
                const promptEvent = this.deferredPrompt;
                if (!promptEvent) {
                    // The deferred prompt isn't available.
                    return;
                }

                // Show the install prompt.
                promptEvent.prompt();
                const result = await promptEvent.userChoice;
                console.log('👍', 'userChoice', result);

                // Reset the deferred prompt variable, since
                // prompt() can only be called once.
                self.deferredPrompt = null;

                // Hide the install button.
                /*$('#install').attr('hidden', true);*/
                $('#install').removeClass('active');
            });



        window.addEventListener('appinstalled', (event) => {
            console.log('👍', 'appinstalled', event);
            // Clear the deferredPrompt so it can be garbage collected
            self.deferredPrompt = null;

            $.ajax({
                type: "get",
                url: 'https://api.actualoptic.kz:8443/patient/app/status/'+ usertoken +'/true',
                success: function (data){
                    console.debug(data);
                },
                error(error) {
                    console.debug(error);
                }
            })
        });


        $('#install-close').click(()=>{
            console.debug('test click')
            global.hasInstall = "false";
            sessionStorage.setItem("hasInstall", global.hasInstall);
            $('#install').removeClass('active');
           /* $('#install').attr('hidden', true);
            $('#install').attr('style', 'display:none');*/
        });


        //определить браузер
        if (localStorage.getItem('safariCheck') === null){
            let getBrowser = () => {
            const userAgent = navigator.userAgent;
            let browser = 'unkown';
            // Detect browser name
            browser = /ucbrowser/i.test(userAgent) ? 'UCBrowser' : browser;
            browser = /edg/i.test(userAgent) ? 'Edge' : browser;
            browser = /googlebot/i.test(userAgent) ? 'GoogleBot' : browser;
            browser = /chromium/i.test(userAgent) ? 'Chromium' : browser;
            browser =
                /firefox|fxios/i.test(userAgent) && !/seamonkey/i.test(userAgent)
                    ? 'Firefox'
                    : browser;
            browser =
                /; msie|trident/i.test(userAgent) && !/ucbrowser/i.test(userAgent)
                    ? 'IE'
                    : browser;
            browser =
                /chrome|crios/i.test(userAgent) &&
                !/opr|opera|chromium|edg|ucbrowser|googlebot/i.test(userAgent)
                    ? 'Chrome'
                    : browser;
            browser =
                /safari/i.test(userAgent) &&
                !/chromium|edg|ucbrowser|chrome|crios|opr|opera|fxios|firefox/i.test(
                    userAgent
                )
                    ? 'Safari'
                    : browser;
            browser = /opr|opera/i.test(userAgent) ? 'Opera' : browser;

            return browser;
        };
            let browser = getBrowser();
            if (browser === "Safari"){
                $('#safari-box-check').attr("checked", "checked").on("click",()=>{
                    localStorage.setItem('safariCheck', 'close')
                })
              }
        }

    }
}